import axiosInstance from "../utils/api";
import endpoints from '../constants/endpoints';

export const AuthServices = {
    login: async (email, password) => {
        try {
            const response = await axiosInstance.post(endpoints.login, { email, password });
            return response.data;
        } catch (error) {
            console.error('Error logging in:', error);
            
            // Enhanced error handling
            if (error.response) {
                // Server responded with error status
                const status = error.response.status;
                const data = error.response.data;
                
                // Handle specific status codes
                switch (status) {
                    case 400:
                        // Bad request - validation errors
                        throw error;
                    case 401:
                        // Unauthorized - wrong credentials
                        if (data.detail) {
                            throw { response: { data: { message: data.detail } } };
                        } else if (data.non_field_errors) {
                            throw { response: { data: { message: data.non_field_errors[0] } } };
                        } else {
                            throw { response: { data: { message: "Invalid email or password" } } };
                        }
                    case 403:
                        // Forbidden
                        throw { response: { data: { message: "Access denied" } } };
                    case 500:
                        // Server error
                        throw { response: { data: { message: "Server error. Please try again later." } } };
                    default:
                        throw error;
                }
            } else if (error.request) {
                // Network error
                throw { 
                    response: { 
                        data: { 
                            message: "Network error. Please check your connection and try again." 
                        } 
                    } 
                };
            } else {
                // Other error
                throw { 
                    response: { 
                        data: { 
                            message: "An unexpected error occurred. Please try again." 
                        } 
                    } 
                };
            }
        }
    },
    
    googleOAuthLogin: async (googleToken) => {
        try {
            const response = await axiosInstance.post(endpoints.googleOAuthLogin, { 
                token: googleToken 
            });
            return response.data;
        } catch (error) {
            console.error('Error with Google OAuth login:', error);
            
            if (error.response) {
                const status = error.response.status;
                const data = error.response.data;
                
                switch (status) {
                    case 400:
                        throw { response: { data: { message: "Invalid Google token" } } };
                    case 401:
                        throw { response: { data: { message: "Google authentication failed" } } };
                    case 500:
                        throw { response: { data: { message: "Server error during Google login" } } };
                    default:
                        throw error;
                }
            } else if (error.request) {
                throw { 
                    response: { 
                        data: { 
                            message: "Network error during Google login" 
                        } 
                    } 
                };
            } else {
                throw { 
                    response: { 
                        data: { 
                            message: "Google login failed. Please try again." 
                        } 
                    } 
                };
            }
        }
    },

    logout: async () => {
        try {
            const response = await axiosInstance.post(endpoints.logout);
            return response.data;
        } catch (error) {
            console.error('Error logging out:', error);
            // Don't throw errors for logout - it should succeed locally even if server fails
            return { message: "Logged out locally" };
        }
    },

    refreshToken: async (refreshToken) => {
        try {
            const response = await axiosInstance.post(endpoints.refreshToken, { refresh_token: refreshToken });
            return response.data;
        } catch (error) {
            console.error('Error refreshing token:', error);
            throw error;
        }
    },

    resetPassword: async (token, password) => {
        try {
            const response = await axiosInstance.post(endpoints.resetPassword, { token, password });
            return response.data;
        } catch (error) {
            throw error;
        }
    }
};